import React from 'react';
import PropTypes from 'prop-types';

import AssociatedTasks from './associated_tasks';

const MobileAssociatedTasksWrapper = ({
  availableDatabases,
  databaseMembers,
  pageSize,
  paths,
  onTaskComplete
}) => {

  return (
    <AssociatedTasks
      availableDatabases={availableDatabases}
      databaseMembers={databaseMembers}
      isItemSpaceActive
      isMobile
      pageSize={pageSize}
      paths={paths}
      onTaskComplete={onTaskComplete}
    />
  );
};

MobileAssociatedTasksWrapper.propTypes = {
  availableDatabases: PropTypes.array.isRequired,
  databaseMembers: PropTypes.array.isRequired,
  pageSize: PropTypes.number,
  paths: PropTypes.shape({
    tasks: PropTypes.string.isRequired
  }).isRequired,
  onTaskComplete: PropTypes.func
};

export default MobileAssociatedTasksWrapper;
